var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-report-panel" },
    [
      _vm.reportStep === 0
        ? _c("ViqReportTypeSelector")
        : [
            _vm.reportType === "board"
              ? _c("ViqBoardReport")
              : _vm.reportType === "timeline"
              ? _c("ViqTimeline")
              : _vm.reportType === "gap-analysis"
              ? _c("ViqGapAnalysis")
              : _vm.reportType === "market-entry"
              ? _c("ViqMarketEntry")
              : _vm.reportType === "compare-markets"
              ? _c("ViqCompareMarkets")
              : _vm.reportType === "expansion"
              ? _c("ViqExpansionOpportunity")
              : _c("ViqReportTypeSelector"),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }